export function clearLocalStorage() {
  localStorage.removeItem("access_token")
  localStorage.removeItem("refresh_token")
  localStorage.removeItem("timeZone")
  localStorage.removeItem("token")
}
